import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_autocomplete = _resolveComponent("autocomplete")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_autocomplete, {
      ref: "autocomplete",
      modelValue: _ctx.query,
      "onUpdate:modelValue": [
        _cache[0] || (_cache[0] = ($event: any) => ((_ctx.query) = $event)),
        _ctx.onSelect
      ],
      "autocomplete-service": _ctx.searcher,
      "exclude-options": _ctx.excludes,
      placeholder: _ctx.selectPlaceholder,
      "clear-search-after-selection": true,
      "no-options-label": _ctx.$msg('profile.creation.completion.wizard.details.skills.error.empty'),
      "focus-after-select": "",
      "data-testid": "input-select-tags",
      onFocus: _ctx.emitFocus
    }, {
      default: _withCtx((slotProps) => [
        _createTextVNode(_toDisplayString(slotProps.option.name), 1)
      ]),
      _: 1
    }, 8, ["modelValue", "autocomplete-service", "exclude-options", "placeholder", "no-options-label", "onUpdate:modelValue", "onFocus"])
  ]))
}